import { Pipe, PipeTransform } from '@angular/core';
import { CatalogTagModel } from 'src/app/views/models/allergen.model';
import { MenuTagModel } from 'src/app/views/models/menu-tag.model';

@Pipe({
  name: 'tagFilter'
})
export class TagFilterPipe implements PipeTransform {

  transform(tags: MenuTagModel[], type: string): MenuTagModel[] {
    let RESULT = [];


    switch (type) {
      case 'allergy':
        RESULT = tags.filter(TAG => {
          try {
            const VALUE: CatalogTagModel = JSON.parse(TAG.name);
            return VALUE.type === 'allergen';
          } catch {
            return false;
          }
        });
    }


    return RESULT;
  }

}
